import { render, staticRenderFns } from "./ExcretionInputGroup.vue?vue&type=template&id=a28cbea4&scoped=true&"
import script from "./ExcretionInputGroup.vue?vue&type=script&lang=ts&"
export * from "./ExcretionInputGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28cbea4",
  null
  
)

export default component.exports